/* global BX24 */
import { useState, useEffect } from "react";

// Определяет, открыта ли страница внутри Bitrix24, и достаёт ID сделки
// из placement info (та же логика, что в PriceListsSummary.js).
export const useBitrixDeal = () => {
    const [isBitrix, setIsBitrix] = useState(false);
    const [dealId, setDealId] = useState(null);

    useEffect(() => {
        try {
            BX24.init(() => {
                setIsBitrix(true);
                const placementInfo = BX24.placement?.info?.();
                const bxDealId = placementInfo?.options?.ID?.toString();
                if (bxDealId) setDealId(bxDealId);

                BX24.resizeWindow(window.innerWidth, 1000, () => {});
            });
        } catch (error) {
            setIsBitrix(false);
        }
    }, []);

    return { isBitrix, dealId };
};
